<template>
  <v-container  style="text-align: center" align="center">
    <v-menu depressed transition="slide-y-transition" bottom left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          style="right: 10px; top: 10px"
          v-bind="attrs"
          v-on="on"
          absolute
          color="#797979"
          icon
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item>
          <p>Heeeey</p>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-badge bordered bottom :color="status" offset-x="32" offset-y="32" dot>
          <v-avatar size="120px" class="customer-image">
            <img v-if="details.profile.profilepicture" :src="details.profile.profilepicture" alt="John" />
            <v-icon v-if="!details.profile.profilepicture" size="60">
              mdi-account-circle
            </v-icon>
          </v-avatar>
        </v-badge>
    <h4>{{ details.profile.firstname + ' ' + details.profile.lastname }}</h4>
    <p>{{ details.email }}</p>
    <p>{{ details.phonenumber }}</p>
    <p class="secondary accent--text pa-2 rounded-pill">Date Registered : {{ date }}</p>
    <p class="secondary dt-border accent--text pa-2 rounded-pill">Time Registered : {{ time }}</p>
    <v-btn depressed @click="suspendUser()" :loading="suspendBtn" color="error" v-if="details.status == 'active' && can('can_manage_users') " dark>Suspend User</v-btn>
    <v-btn depressed @click="activateUser()" :loading="activateBtn" color="success" v-if="details.status == 'suspended' && can('can_manage_users') " dark>Activate User</v-btn>
  </v-container>
</template>

<script>
import { parseTimestamp } from '@/utils/dates'
import { UsersService } from '@/services';
export default {
  props: {
    details: Object,
  },
  data: () => ({
    suspendBtn : false,
    activateBtn : false
  }),
  mounted(){
  },
  methods:{
    async suspendUser(){
      try {
        this.suspendBtn = true;
        const data = await UsersService.SuspendUser({
          id : this.details.id
        });
        this.suspendBtn = false
        this.$store.dispatch('toast', {
          message: data.message,
          variant: 'success'
        });
        this.details.status = data.user.status
      } catch (error) {
        this.suspendBtn = false;
      }
    },
    async activateUser(){
      try {
        this.activateBtn = true;
        const data = await UsersService.ActivateUser({
          id : this.details.id
        })
        this.$store.dispatch('toast', {
          message: data.message,
          variant: 'success'
        });
        this.details.status = data.user.status
        this.activateBtn = false
      } catch (error) {
        this.activateBtn = false
      }
    }
  },
  computed:{
    status(){
      let color = ( this.details.status === 'active' ) ? 'green' : 'red'
      return color
    },
    date(){
      const longEnUSFormatter = new Intl.DateTimeFormat('en-US', {
        year:  'numeric',
        month: 'long',
        day:   'numeric',
      });
      return longEnUSFormatter.format(new Date(this.details.created))
    },
    time(){
      return parseTimestamp(new Date(this.details.created), 'HH:mm')
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/Global/scss/variables.scss";
.customer-image {
  border: 3px solid #fff;
  margin-bottom: 15px;
}
h4 {
  font-size: 18px;
  font-weight: 600;
  color: $Dtunes-text;
  margin-bottom: 5px;
}
p {
  font-size: 15px;
  color: $Dtunes-grey;
  letter-spacing: 0.5px;
  margin-bottom: 10px;
}
.customer-btn {
  margin-top: 20px;
  padding: 10px 20px !important;
}
</style>